import SelectInput from '../Common/SelectInput';

const SelectWrapper = ({ ...objProps }) => {
  return <SelectInput {...objProps.field} {...objProps} />;
};

export default SelectWrapper;
